// src/beta/components/DocumentsLibrary.tsx
import { useState } from 'react';
import { DocumentTile } from '@/beta/components/DocumentTile';
import { DocumentModal } from '@/beta/components/DocumentModal';
import type { V1DocumentSummary } from '@/beta/types/dossier';

interface Props {
  documents: V1DocumentSummary[];
}

/** § 6.4 (4) wrapper: documents grid + modal-open state. */
export function DocumentsLibrary({ documents }: Props) {
  const [activeDocId, setActiveDocId] = useState<string | null>(null);

  if (documents.length === 0) {
    return (
      <p style={{ color: 'var(--vm-stone)', fontSize: 13, fontFamily: 'var(--vm-font-body)' }}>
        No documents on file.
      </p>
    );
  }

  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
          gap: 'var(--vm-s-2)',
        }}
      >
        {documents.map((d) => (
          <DocumentTile key={d.id} doc={d} onTap={(id) => setActiveDocId(id)} />
        ))}
      </div>

      {activeDocId && (
        <DocumentModal docId={activeDocId} onClose={() => setActiveDocId(null)} />
      )}
    </>
  );
}
